module.exports = __webpack_public_path__ + "static/media/bg_right.1b49b552.png";